import { useContext, useMemo } from 'react';
import { CreditsContext } from '@/services/CreditsContext';
import { formatNumberToShortString } from '@/utils/numbers';

const MIN_CREDITS_FOR_LOW_CREDITS = 100;

export function useCreditsBalanceDisplay() {
  const { credits, handleGetMoreCreditsClick } = useContext(CreditsContext);

  const creditsDisplayText = useMemo(() => {
    return credits !== null ? formatNumberToShortString(credits) : '0';
  }, [credits]);

  const isLowCredits = useMemo(() => {
    return credits !== null && credits < MIN_CREDITS_FOR_LOW_CREDITS;
  }, [credits]);

  return {
    creditsDisplayText,
    isLowCredits,
    handleGetMoreCreditsClick,
  };
}
